import { axiosInstance, tdraxiosInstance } from './axiosInstance';

export const userInquiryData = async () => {
    try {
        const response = await axiosInstance.get('/api/v1/user-inquiry');
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const getInquiryDataByID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/inquiry-data/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const userRegister = async (data) => {
    try {
        const response = await tdraxiosInstance.post('/api/v1/registration', data);
        return response;
    } catch (error) {
        return error.response || error;
    }
}